import { render, staticRenderFns } from "./BackToSettings.vue?vue&type=template&id=4b766d80&"
import script from "./BackToSettings.vue?vue&type=script&lang=js&"
export * from "./BackToSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports